import React, { useState, useEffect } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Header from "./Header";
import NavItems from "./NavItems";
import { makeStyles } from "tss-react/mui";
import SelectDomain from "./SelectDomain";
import Settings from "./Settings";
import { TOGGLE_SIDEBAR } from "../../../utils/posthogEvents";
import { usePostHog } from "posthog-js/react";
import { useLocation } from "react-router-dom";
import { PID_URL } from "../../../utils/routes";

const useStyles = makeStyles()((theme, { expanded }, classes) => ({
  root: {
    width: expanded ? 240 : 72,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    paddingTop: 8,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

function Sidebar() {
  const theme = useTheme();
  const posthog = usePostHog();
  const isXS = useMediaQuery(theme.breakpoints.down("sm"));
  const [expanded, setExpanded] = useState(isXS ? false : true);
  const { classes } = useStyles({ expanded });
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const hasFileId = searchParams.has("fileId");
    const hasSessionId =
      pathname !== PID_URL && pathname.startsWith(PID_URL + "/");

    if (hasSessionId || (pathname === PID_URL && hasFileId)) {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  }, [pathname, location.search]);

  const handleToggleExpand = (value) => {
    setExpanded(value);
    posthog.capture(TOGGLE_SIDEBAR, { expanded: value });
  };

  return (
    <Box className={classes.root}>
      <Header expanded={expanded} onToggleExpand={handleToggleExpand} />
      <SelectDomain expanded={expanded} />
      {/* <Box mb={2} />
      <NewSession expanded={expanded} /> */}
      {expanded && <Box mb={1} />}
      <NavItems expanded={expanded} />
      <Settings expanded={expanded} />
    </Box>
  );
}

export default Sidebar;
